__turbopack_context__.v({
  "icon": "styles-module-scss-module__PDcflW__icon",
  "icon__modLg": "styles-module-scss-module__PDcflW__icon__modLg",
  "icon__modMd": "styles-module-scss-module__PDcflW__icon__modMd",
  "icon__modSm": "styles-module-scss-module__PDcflW__icon__modSm",
  "icon__modXl": "styles-module-scss-module__PDcflW__icon__modXl",
});
